module.exports = __webpack_public_path__ + "public/images/explore-blob.cfabfc7cc5086f65188c5477c9d69582.svg";